/* eslint-disable max-len */
import React, { useCallback, useEffect, useState } from 'react';
import CardHeader from '../../../components/CardHeader';
import Pagination from '../../../components/Pagination';
import { useNavigate, useSearchParams } from 'react-router-dom';
import TopBarWithShadow from '../../../components/TopBar/TopBarWithShadow';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import { dataService } from '../../../services/data.services';
import { formatAdjustedDate, formatDateTime } from '../../../CommonMethods/formatDate';
import ItemShimmer from '../../../components/Shimmer/itemShimmer';
import moment from "moment";


const statusStyles = {
    'In Progress': 'bg-yellow-100 text-yellow-800',
    'Completed': 'bg-green-100 text-green-800',
};

const handleBulkStatus = (status, key) => {
    const val = {
        'in_progress': { status: 'In Progress', img: 'draft-img.svg', color: 'bg-[#FFEEB0]' },
        'completed': { status: 'Completed', img: 'successDot.svg', color: 'bg-[#C5FFD5]' },
        default: { status: 'Pending', img: 'bluedot.svg', color: 'bg-[#FEF9C3]' }
    };
    return (val[status] || val.default)[key];
};

function BulkInvoiceHistory() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams({bulk_page_number:1});
    const [page, setPage] = useState(1);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedName, setSelectedName] = useState(searchParams?.get('main') !== null ? searchParams?.get('main'):'')  ;
    const [finacialYear, setFinacialYear] = useState('')
    const [loading, setLoading] = useState(true);
    const [FYLoading, setFYLoading] = useState(true);
    const [currentFinacialYear, setCurrentFinacialYear] = useState('')
    const [toastErrorMessage, setToastErrorMessage] = useState("")
    const [bulkInvoiceList, setBulkInvoiceList] = useState([])
    const [bulkInvoiceCount, setBulkInvoiceCount] = useState(0)

    const handleOnClickPageNumber = (pageNum) => {
        setLoading(true);
        const params = Object.fromEntries(searchParams);
        setSearchParams({ ...params, bulk_page_number: pageNum.selected + 1 });
    };

    const getBulkInvoiceList = useCallback(async () => {
        // if(searchParams?.get('search') === null){
        //     setsearchFieldDebounce('')
        // }
        // Continue with the rest of the function after classes and sections are set
        
        try { 
            setLoading(true)     
            const branch_id = await GetBranchId()
            let endpoint = `invoice/list-bulk-issue?branch_id=${branch_id}&page_number=${
                searchParams?.get('bulk_page_number')===null ? '1' : searchParams?.get('bulk_page_number')}${
                searchParams?.get('start_date') === null ?`&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams?.get('start_date')}`}${
                searchParams?.get('end_date') === null ? `&end_date=${endDate.substring(0, 10)}` :`&end_date=${searchParams?.get('end_date')}`}`
            const response = await dataService.GetAPI(endpoint)
            const temp = response?.data?.data?.data
            console.log(temp)
            const temp2 = response?.data?.data?.total_count
            // const temp3 = response?.data?.data?.all_total_count
            // const temp4 = response?.data?.data?.report_total
            setBulkInvoiceList(temp)
            setBulkInvoiceCount(temp2);
            // setFeeCollectionTotalCount(temp3)    
            // setReportTotal(temp4)
        } catch(error) {
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        } finally{
            setLoading(false)
            // updateFilterCheckBox();
        }
    }, [searchParams, FYLoading]);
    
    const calculateEndDate = (fyEndDate) => {
        const fyEndDate1 = new Date(fyEndDate);
        const currentDate = moment().endOf('day');
        return currentDate <= fyEndDate1 ? currentDate.toISOString() : fyEndDate;
    }

    const getFinancialYears = async() => {
        try {
            const branch_id = await GetBranchId()
            let endpoint = `financial-years?branch_id=${branch_id}&filter=true&status=open,closed,ongoing&sort=start_date%2Bdesc`;
            const response = await dataService.GetAPI(endpoint, true)
            const temp1 = response?.data?.data?.financial_years
            setFinacialYear(temp1)
            const selectedFY = JSON.parse(localStorage.getItem('FY_details'));
            setCurrentFinacialYear(selectedFY.name)
            setSelectedName(searchParams?.get('main') !== null ? searchParams?.get('main') : selectedFY.name)
            const ongoingFYData = temp1.find(item => item.name === selectedFY.name);
            // If there's ongoing data, set the start and end dates in the state
            if (ongoingFYData) {
                setStartDate(ongoingFYData.start_date);
                setEndDate(calculateEndDate(ongoingFYData.end_date));
            }
        }
        catch (error) {
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        }
        finally {
            setFYLoading(false)
        }
        // setSearchParams({})
    }

    useEffect(() => {
        if (startDate != null && !FYLoading) {
            getBulkInvoiceList();
        }
    }, [startDate, searchParams, FYLoading]);

    useEffect(()=>{
        getFinancialYears()    
    },[])

    return (
        <CardHeader noPadding>
            <TopBarWithShadow
                Tittle="Bulk Invoice Issue History"
                isback={true}
                backLocation = { `/student-master/invoice-list?${searchParams.toString()}`}
            />
            <div className="mainDataCntnrListDiv">
                {loading ? (
                    <ItemShimmer classkey={"mt-[32px]"}/>
                ) : (    
                    <div class='-mx-1 '>
                        <div className="text-center absolute w-full">
                            <span className="">
                                Date of Issue from <span className="font-semibold">{searchParams?.get('start_date') === null ? formatAdjustedDate(startDate) : formatAdjustedDate(searchParams?.get('start_date'))}</span> to <span className="font-semibold">{searchParams?.get('end_date') === null ? formatAdjustedDate(endDate, true) : formatAdjustedDate(searchParams?.get('end_date'))}</span>
                            </span>
                        </div>
                        <div className="flex overflow-auto pb-[10px] scroll-bar px-1 topHeading" id="search-result">
                            <table
                                aria-label="Outside Table"
                                className="w-full"
                                id="admin-table"
                            >
                                <thead>
                                    <tr>
                                        <th className="w-[9%] text-left">
                                            <span>Date of Issue</span>
                                        </th>
                                        <th className="w-[12%] text-left">
                                            <span>Issued by</span>
                                        </th>
                                        <th className="w-[10%] text-left">
                                            <span>AY</span>
                                        </th>
                                        <th className="w-[10%] text-center">
                                            <span>Total # of Students</span>
                                        </th>
                                        <th className="w-[10%] text-center">
                                            <span># of invoices issued</span>
                                        </th>
                                        <th className="w-[10%] text-center">
                                            <span># of invoices failed</span>
                                        </th>
                                        <th className="w-[8%] text-center">
                                            <span>Status</span>
                                        </th>
                                        <th className="w-[8%] text-center">
                                            <span>Actions</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bulkInvoiceList?.map((row, idx) => (
                                        <tr key={idx} class='cursor-pointer'
                                            title={'View Invoice Issue Status'}
                                            onClick={(e) => {
                                                const params = new URLSearchParams(searchParams)
                                                params.set('transaction_id', row._id)
                                                navigate(`/student-master/invoice-list/bulk-invoice-history/invoice-issue-status?${params.toString()}`)
                                            }}
                                        >
                                            <td className="text-left">{formatAdjustedDate(row?.issue_date)}</td>
                                            <td className="text-left">{row.created_by}</td>
                                            <td className="text-left">{`${row.academic_year}, ${row.class_name}${row?.section_name?.trim() ? `, ${row.section_name}` : ''}`}</td>
                                            <td className="text-center">{row.total_students}</td>
                                            <td className="text-center">{row.invoice_issue_count}</td>
                                            <td className="text-center">{row.invoice_failed_count}</td>
                                            <td className="text-center">
                                                <div className="flex justify-center">
                                                    <div className={`w-fit rounded ${handleBulkStatus(row?.transaction_status, 'color')} 
                                                        flex items-center justify-center py-1.5 px-2 2xl:px-2.5`}>
                                                        <img loading="lazy" decoding="async"
                                                            src={`/images/${handleBulkStatus(row?.transaction_status, 'img')}`} alt="icon" />
                                                        <span className="text-f7 font-normal text-[#031624] pl-1">
                                                            {handleBulkStatus(row?.transaction_status, 'status')}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="text-center">
                                                <button
                                                    className="list-actn-btn prevent-click"
                                                    onClick={() => {
                                                        const params = new URLSearchParams(searchParams)
                                                        params.set('transaction_id', row._id)

                                                        navigate(`/student-master/invoice-list/bulk-invoice-history/invoice-issue-status?${params.toString()}`)
                                                    }}
                                                >
                                                    View
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                {bulkInvoiceList.length === 0 && (
                                    <tbody>
                                        <tr>
                                            <td style={{ 'line-height': '100px'}} colspan="8" className="no-records-message">
                                                {'No records found'}
                                            </td>
                                        </tr>
                                    </tbody>
                                )}
                            </table>

                        </div>
                        {(bulkInvoiceCount > 10) && <Pagination
                            TotalCount={bulkInvoiceCount}
                            totalPageNumber={Math.ceil(bulkInvoiceCount / 10)}
                            selectedPageNumber={Number(searchParams.get('bulk_page_number')) || 1}
                            handleOnClickPageNumber={handleOnClickPageNumber}
                        />
                        }  
                    </div>        
                )} 
            </div>                    
           

        </CardHeader>
    );
}

export default BulkInvoiceHistory; 